var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50002 4.5C8.87013 4.5 8.26604 4.76339 7.82064 5.23223C7.37524 5.70107 7.12502 6.33696 7.12502 7C7.12502 7.66304 7.37524 8.29893 7.82064 8.76777C8.26604 9.23661 8.87013 9.5 9.50002 9.5C10.1299 9.5 10.734 9.23661 11.1794 8.76777C11.6248 8.29893 11.875 7.66304 11.875 7C11.875 6.33696 11.6248 5.70107 11.1794 5.23223C10.734 4.76339 10.1299 4.5 9.50002 4.5ZM9.50002 11.1667C8.45021 11.1667 7.44339 10.7277 6.70106 9.94628C5.95872 9.16488 5.54169 8.10507 5.54169 7C5.54169 5.89493 5.95872 4.83512 6.70106 4.05372C7.44339 3.27232 8.45021 2.83333 9.50002 2.83333C10.5498 2.83333 11.5567 3.27232 12.299 4.05372C13.0413 4.83512 13.4584 5.89493 13.4584 7C13.4584 8.10507 13.0413 9.16488 12.299 9.94628C11.5567 10.7277 10.5498 11.1667 9.50002 11.1667ZM9.50002 0.75C5.54169 0.75 2.16127 3.34167 0.791687 7C2.16127 10.6583 5.54169 13.25 9.50002 13.25C13.4584 13.25 16.8388 10.6583 18.2084 7C16.8388 3.34167 13.4584 0.75 9.50002 0.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e20f831cf0f52f4b7ae80c7cbd0452b4.svg";
export { ForwardRef as ReactComponent };